import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=883c46f8&scoped=true"
import script from "./role_card.js?vue&type=script&lang=js&external"
export * from "./role_card.js?vue&type=script&lang=js&external"
import style0 from "./role_card.scss?vue&type=style&index=0&id=883c46f8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883c46f8",
  null
  
)

export default component.exports